import styled from 'styled-components';

import { mainCq } from 'bdvp-common/src/styles/helpers/main-cq';

import Share from './Share';

const ShareReelWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    padding-top: 15px;
    ${mainCq.md`
        max-width: 30%;
        padding: 0px;
        position: absolute;
        right: 0;
        top: -5px;
        margin-bottom: 10px;
    `}

    ${Share} {
        margin-left: 20px;
    }
`;

export default ShareReelWrapper;
